/* ==========================================================================
   GRIPT SPORT — shared runtime: layout, catalog helpers, cart, motion
   ========================================================================== */
(() => {
  const STORE = (window.GRIPT_CTX || {}).store ?? 'https://griptsport.com';
  const LOGO = (window.GRIPT_CTX || {}).logo || 'logo.png';
  const FREE_SHIP = 18;
  const P = window.GRIPT_PRODUCTS || [];
  const byHandle = Object.fromEntries(P.map(p => [p.handle, p]));
  // the bundle's "was" price is what its three items actually cost bought separately
  const PARTS = ['magnetic-gym-bag', 'palm-protectors', 'mini-massage-gun'];
  if (byHandle['essentials-gym-bundle'] && PARTS.every(h => byHandle[h])) {
    const sep = Math.round(PARTS.reduce((s, h) => s + (byHandle[h].variants.find(v => v.available) || byHandle[h].variants[0]).price, 0) * 100) / 100;
    byHandle['essentials-gym-bundle'].variants.forEach(v => { v.compare = sep; });
  }
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // remote Shopify images get resized by the CDN; local copies (artifact build) are used as-is
  const img = (src, w) => !src ? '' : !/^https?:/.test(src) ? src : src + (src.includes('?') ? '&' : '?') + 'width=' + w;
  const money = n => '$' + n.toFixed(2);
  const name = p => p.title.replace(/^GRIPT\s+/, '').replace(/\s+[—–-]\s+Black$/, '');
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const minPrice = p => Math.min(...p.variants.map(v => v.price));
  const compare = p => p.variants[0].compare && p.variants[0].compare > p.variants[0].price ? p.variants[0].compare : null;
  const colorOpt = p => p.options.find(o => /color/i.test(o.name));
  const SWATCH = { black: '#111', white: '#f5f5f5', pink: '#f4b8c8', grey: '#8d8d8d', gray: '#8d8d8d' };

  const COLLECTIONS = {
    'shop-all': { title: 'Shop All', kicker: 'Every piece', blurb: 'Carry, grip, hydration, recovery and apparel. The full GRIPT training system in one place.', hero: 'magnetic-gym-bag', heroIdx: 3 },
    'gym-essentials': { title: 'Gym Essentials', kicker: 'Carry + recover', blurb: 'The gear that keeps your session organized from the first set to the last stretch.', hero: 'magnetic-gym-bag', heroIdx: 2 },
    'strength-grip': { title: 'Strength & Grip', kicker: 'Hold the line', blurb: 'When your grip is the weak link, fix the link. Hooks and protectors for heavy pulls.', hero: 'palm-protectors', heroIdx: 2 },
    'hydration': { title: 'Hydration', kicker: 'Fuel between sets', blurb: 'Bottles and shakers built to live on the rack, not the floor.', hero: 'electric-protein-shaker', heroIdx: 2 },
    'apparel': { title: 'Apparel', kicker: 'Wear the work', blurb: 'Heavyweight fleece and clean caps. Built for training, designed to stand on their own.', hero: 'essential-oversized-boxy-fit-fleece-hoodie-1', heroIdx: 0 },
    'fw26-drop': { title: 'FW26 Drop', kicker: 'Limited capsule', blurb: 'Heavy fleece. Boxy cut. The FW26 capsule in washed black.', hero: 'essential-oversized-boxy-fit-fleece-hoodie-1', heroIdx: 1 },
  };
  const inCollection = (h) => h === 'shop-all' ? P : P.filter(p => p.collections.includes(h));
  const isNew = p => p.collections.includes('fw26-drop');

  /* ---------------- icons ---------------- */
  const I = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8h18M3 16h18"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 5 14 14M19 5 5 19"/></svg>',
    arrow: '<svg class="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12h15M13 6l6 6-6 6"/></svg>',
    arrowUR: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17 17 7M8 7h9v9"/></svg>',
    left: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 12H5M11 6l-6 6 6 6"/></svg>',
    right: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12h15M13 6l6 6-6 6"/></svg>',
    ig: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>',
    tt: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.8 5.8 0 1 0 5 5.7V9.1a7.3 7.3 0 0 0 4.3 1.4V7.4a4.3 4.3 0 0 1-3.3-1.6Z"/></svg>',
    yt: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12a31 31 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8ZM9.8 15V9l5.8 3-5.8 3Z"/></svg>',
    magnet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 3v9a6 6 0 0 0 12 0V3h-4v9a2 2 0 0 1-4 0V3H6Z"/><path d="M6 7h4M14 7h4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2 6h12v10H2zM14 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    flag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 21V4M5 4h12l-2 4 2 4H5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>',
  };

  /* ---------------- product card ---------------- */
  function card(p, opts = {}) {
    const cmp = compare(p);
    const price = minPrice(p);
    const col = colorOpt(p);
    const sizeOpt = p.options.find(o => /size/i.test(o.name) && o.values.length > 1);
    const multi = p.variants.length > 1;
    const badge = cmp ? `<span class="badge badge--sale">Save ${Math.round((1 - price / cmp) * 100)}%</span>`
      : isNew(p) ? '<span class="badge badge--new">New · FW26</span>'
      : p.handle === 'magnetic-gym-bag' ? '<span class="badge">Best seller</span>' : '';
    const quick = multi
      ? `<p>Quick add · ${esc(sizeOpt ? 'Select size' : 'Select option')}</p><div class="vs">${p.variants.map(v => `<button type="button" data-add="${v.id}" data-h="${p.handle}" ${v.available ? '' : 'disabled'}>${esc(sizeOpt ? v.options[p.options.indexOf(sizeOpt)] : v.title)}</button>`).join('')}</div>`
      : `<button type="button" class="add1" data-add="${p.variants[0].id}" data-h="${p.handle}">Quick add +</button>`;
    return `<article class="card" ${opts.reveal === false ? '' : 'data-card'}>
      <div class="card__frame">
      <a class="card__media" href="/products/${p.handle}" data-cursor="View" aria-label="${esc(name(p))}">
        ${badge}
        <img src="${img(p.images[0], 700)}" alt="${esc(name(p))}" loading="lazy">
        ${p.images[1] ? `<img class="alt" src="${img(p.images[1], 700)}" alt="" loading="lazy">` : ''}
      </a>
      <div class="card__quick">${quick}</div>
      </div>
      <div class="card__info">
        <a href="/products/${p.handle}">${esc(name(p))}</a>
        <span class="price">${cmp ? `<span class="sale">${money(price)}</span><s>${money(cmp)}</s>` : money(price)}</span>
        <span class="t">${esc(p.type)}${col && col.values.length > 1 ? ` · ${col.values.length} colors` : ''}</span>
        ${col ? `<span class="swatches">${col.values.map(c => `<i style="background:${SWATCH[c.toLowerCase()] || '#ccc'}" title="${esc(c)}"></i>`).join('')}</span>` : ''}
      </div>
    </article>`;
  }

  /* ---------------- layout ---------------- */
  const page = document.body.dataset.page || '';
  const navCount = h => inCollection(h).length;

  function header() {
    const link = (href, label, key, extra = '') => `<a href="${href}" ${page === key ? 'aria-current="page"' : ''}>${label}${extra}</a>`;
    const f1 = byHandle['essential-oversized-boxy-fit-fleece-hoodie-1'];
    const f2 = byHandle['magnetic-gym-bag'];
    return `
    <div class="top" id="top">
      <div class="announce" aria-label="Announcements"><div class="announce__track">${Array(8).fill('<span>Free shipping on orders $18+</span><span>Delivered in 3–10 days</span><span>FW26 capsule — now live</span><span>Train hard. Stay GRIPT.</span>').join('')}</div></div>
      <header class="hdr" id="hdr">
        <div class="wrap hdr__in">
          <nav class="hdr__nav" aria-label="Primary">
            <button type="button" id="megaBtn" aria-expanded="false" aria-controls="mega" ${page === 'shop' ? 'aria-current="page"' : ''}>Shop</button>
            ${link('/pages/drop', 'FW26 Drop', 'drop', '<span class="tag">NEW</span>')}
            ${link('/pages/about-us', 'About', 'about')}
            ${link('/pages/contact', 'Support', 'support')}
          </nav>
          <a class="hdr__logo" href="/" aria-label="GRIPT Sport home"><img src="${LOGO}" alt="GRIPT"></a>
          <div class="hdr__act">
            <button class="icon-btn" type="button" data-open-search aria-label="Search">${I.search}</button>
            <a class="icon-btn hide-m" href="${STORE}/account" aria-label="Account">${I.user}</a>
            <button class="icon-btn" type="button" data-open-cart aria-label="Cart">${I.bag}<span class="cart-count" id="cartCount">0</span></button>
            <button class="icon-btn hdr__burger" type="button" id="burger" aria-label="Menu">${I.menu}</button>
          </div>
        </div>
        <div class="mega" id="mega">
          <div class="wrap mega__in">
            <div><h4>Shop by system</h4><ul>
              ${['shop-all', 'gym-essentials', 'strength-grip', 'hydration', 'apparel'].map(h => `<li><a href="/collections/${h}">${COLLECTIONS[h].title}<small>${navCount(h)}</small></a></li>`).join('')}
            </ul></div>
            <div><h4>Featured</h4><ul>
              <li><a href="/pages/drop">FW26 Capsule<small>New</small></a></li>
              <li><a href="/products/essentials-gym-bundle">The Starter System</a></li>
              <li><a href="/products/magnetic-gym-bag">Magnetic Bag</a></li>
            </ul></div>
            <a class="mega__feat" href="/pages/drop"><img src="${img(f1.images[0], 800)}" alt="" loading="lazy"><span>FW26 Drop</span></a>
            <a class="mega__feat" href="/products/magnetic-gym-bag"><img src="${img(f2.images[3], 800)}" alt="" loading="lazy"><span>The Magnetic Bag</span></a>
          </div>
        </div>
      </header>
    </div>
    <div class="scrim" id="scrim"></div>
    <nav class="mnav" id="mnav" aria-label="Mobile">
      <div class="mnav__top"><img src="${LOGO}" alt="GRIPT"><button class="icon-btn" type="button" data-close-mnav aria-label="Close menu">${I.close}</button></div>
      <ul>
        <li><a href="/collections/shop-all">Shop All <span>${P.length}</span></a></li>
        <li><a href="/pages/drop">FW26 Drop <span>New</span></a></li>
        <li><a href="/collections/gym-essentials">Essentials <span>${navCount('gym-essentials')}</span></a></li>
        <li><a href="/collections/strength-grip">Strength &amp; Grip <span>${navCount('strength-grip')}</span></a></li>
        <li><a href="/collections/hydration">Hydration <span>${navCount('hydration')}</span></a></li>
        <li><a href="/collections/apparel">Apparel <span>${navCount('apparel')}</span></a></li>
        <li><a href="/pages/about-us">About <span>→</span></a></li>
        <li><a href="/pages/contact">Support <span>→</span></a></li>
      </ul>
      <div class="mnav__foot"><a href="https://www.instagram.com/griptsport">Instagram</a><a href="https://www.tiktok.com/@griptsport">TikTok</a><a href="https://www.youtube.com/@griptsport">YouTube</a></div>
    </nav>
    <div class="search" id="search" role="dialog" aria-label="Search">
      <div class="wrap">
        <div class="search__bar">${I.search}<input id="q" type="search" placeholder="Search gear" autocomplete="off"><button class="icon-btn" type="button" data-close-search aria-label="Close search">${I.close}</button></div>
        <div class="search__hint"><span class="mono" style="color:var(--mute)">Popular:</span>${['Magnetic bag', 'Hoodie', 'Hooks', 'Shaker', 'Massage gun'].map(t => `<button class="chip" type="button" data-q="${t}">${t}</button>`).join('')}</div>
        <div class="search__res" id="sres"></div>
      </div>
    </div>
    <aside class="drawer" id="drawer" aria-label="Cart">
      <div class="drawer__hd"><h3>Your bag<sup id="dCount">0</sup></h3><button class="icon-btn" type="button" data-close-cart aria-label="Close cart">${I.close}</button></div>
      <div class="ship" id="ship">${I.truck}<div><p id="shipMsg"></p><div class="ship__bar"><i id="shipBar"></i></div></div></div>
      <div class="drawer__items" id="dItems"></div>
      <div class="drawer__ft" id="dFt"></div>
    </aside>
    <div class="toast" id="toast" role="status"></div>
    <div class="cursor" id="cursor"><span></span></div>`;
  }

  function footer() {
    return `
    <footer class="ftr">
      <div class="wrap">
        <div class="ftr__top">
          <div class="ftr__news">
            <h3 class="display d-s">Join the crew</h3>
            <p>Drops, restocks and training notes. No spam — just the good stuff.</p>
            <form class="news" data-news><input type="email" required placeholder="Email address" aria-label="Email address"><button type="submit">Join ${I.right}</button></form>
            <p class="form-ok">You're in. Watch your inbox.</p>
            <div class="ftr__social">
              <a href="https://www.instagram.com/griptsport" aria-label="Instagram">${I.ig}</a>
              <a href="https://www.tiktok.com/@griptsport" aria-label="TikTok">${I.tt}</a>
              <a href="https://www.youtube.com/@griptsport" aria-label="YouTube">${I.yt}</a>
            </div>
          </div>
          <div><h4>Shop</h4><ul>
            ${['shop-all', 'gym-essentials', 'strength-grip', 'hydration', 'apparel'].map(h => `<li><a href="/collections/${h}">${COLLECTIONS[h].title}</a></li>`).join('')}
            <li><a href="/pages/drop">FW26 Drop</a></li>
          </ul></div>
          <div><h4>Help</h4><ul>
            <li><a href="/pages/contact">Contact us</a></li>
            <li><a href="/pages/contact#faq">FAQ</a></li>
            <li><a href="${STORE}/policies/shipping-policy">Shipping</a></li>
            <li><a href="${STORE}/policies/refund-policy">Returns</a></li>
            <li><a href="${STORE}/account">Track order</a></li>
          </ul></div>
          <div><h4>GRIPT</h4><ul>
            <li><a href="/pages/about-us">Our story</a></li>
            <li><a href="/pages/about-us#principles">Principles</a></li>
            <li><a href="/products/essentials-gym-bundle">Starter system</a></li>
          </ul></div>
        </div>
      </div>
      <div class="ftr__mark" aria-hidden="true" data-mark>${'GRIPT'.split('').map(c => `<span>${c}</span>`).join('')}</div>
      <div class="ftr__legal"><div class="wrap" style="display:flex;justify-content:space-between;gap:20px;flex-wrap:wrap">
        <span>© ${new Date().getFullYear()} GRIPT Sport. Built for every rep.</span>
        <nav><a href="${STORE}/policies/privacy-policy">Privacy</a><a href="${STORE}/policies/terms-of-service">Terms</a><a href="${STORE}/policies/refund-policy">Refunds</a></nav>
      </div></div>
    </footer>`;
  }

  document.body.insertAdjacentHTML('afterbegin', `<div class="pt" id="pt"><img src="${LOGO}" alt=""></div>` + header());
  document.body.insertAdjacentHTML('beforeend', footer());

  /* ---------------- overlays ---------------- */
  const scrim = $('#scrim'), drawer = $('#drawer'), mnav = $('#mnav'), search = $('#search'), mega = $('#mega'), megaBtn = $('#megaBtn'), hdr = $('#hdr');
  let lenis = null;
  const lock = on => { document.body.classList.toggle('is-locked', on); if (lenis) on ? lenis.stop() : lenis.start(); };
  const closeAll = () => { drawer.classList.remove('is-open'); mnav.classList.remove('is-open'); search.classList.remove('is-open'); scrim.classList.remove('is-on'); setMega(false); lock(false); };
  function setMega(on) { mega.classList.toggle('is-open', on); megaBtn.setAttribute('aria-expanded', on); hdr.classList.toggle('is-mega', on); if (!drawer.classList.contains('is-open')) scrim.classList.toggle('is-on', on); }
  const openCart = () => { closeAll(); renderCart(); drawer.classList.add('is-open'); scrim.classList.add('is-on'); lock(true); };

  let megaT;
  megaBtn.addEventListener('click', () => setMega(!mega.classList.contains('is-open')));
  [megaBtn, mega].forEach(el => {
    el.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) { clearTimeout(megaT); setMega(true); } });
    el.addEventListener('mouseleave', () => { megaT = setTimeout(() => setMega(false), 180); });
  });
  scrim.addEventListener('click', closeAll);
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', openCart));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', closeAll));
  $('#burger').addEventListener('click', () => { mnav.classList.add('is-open'); lock(true); });
  $$('[data-close-mnav]').forEach(b => b.addEventListener('click', closeAll));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); if (e.key === '/' && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); } });

  /* search */
  const q = $('#q'), sres = $('#sres');
  function openSearch() { closeAll(); search.classList.add('is-open'); lock(true); runSearch(); setTimeout(() => q.focus(), 60); }
  function runSearch() {
    const t = q.value.trim().toLowerCase();
    const list = t ? P.filter(p => (p.title + ' ' + p.type + ' ' + p.collections.join(' ')).toLowerCase().includes(t) || t.split(/\s+/).every(w => (p.title + ' ' + p.type).toLowerCase().includes(w))) : P.slice(0, 6);
    sres.innerHTML = list.length ? list.map(p => `<a class="sres" href="/products/${p.handle}"><img src="${img(p.images[0], 400)}" alt="" loading="lazy"><b>${esc(name(p))}</b><span>${money(minPrice(p))}</span></a>`).join('')
      : `<p class="lede">Nothing matched “${esc(q.value)}”. Try “bag” or “hoodie”.</p>`;
  }
  $$('[data-open-search]').forEach(b => b.addEventListener('click', openSearch));
  $$('[data-close-search]').forEach(b => b.addEventListener('click', closeAll));
  q.addEventListener('input', runSearch);
  $$('[data-q]').forEach(b => b.addEventListener('click', () => { q.value = b.dataset.q; runSearch(); }));

  /* newsletter + contact forms: posted to Shopify inside the theme, front-end only on the static site */
  const SHOP_FORMS = !!(window.GRIPT_CTX || {}).cart;
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-news],[data-form]');
    if (!f) return;
    if (SHOP_FORMS) {
      const news = f.matches('[data-news]');
      const set = (n, v) => { let i = f.querySelector(`input[type=hidden][name="${n}"]`); if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = n; f.append(i); } i.value = v; };
      f.method = 'post'; f.action = '/contact';
      set('form_type', news ? 'customer' : 'contact'); set('utf8', '✓');
      if (news) { f.querySelector('input[type=email]').name = 'contact[email]'; set('contact[tags]', 'newsletter'); }
      else {
        const [nm, em, ord] = f.querySelectorAll('input:not([type=hidden])');
        nm.name = 'contact[name]'; em.name = 'contact[email]'; ord.name = 'contact[order]'; f.querySelector('textarea').name = 'contact[body]';
      }
      return; // let the browser post it; Shopify redirects back with ?customer_posted / ?contact_posted
    }
    e.preventDefault();
    const box = f.parentElement;
    box.classList.add('is-sent');
    f.reset();
  });
  const posted = location.search.match(/[?&](customer|contact)_posted=true/);
  if (posted) $$(posted[1] === 'customer' ? '[data-news]' : '[data-form]').forEach(f => f.parentElement.classList.add('is-sent'));

  /* ---------------- cart ---------------- */
  const KEY = 'gript-cart-v1';
  const vIndex = {};
  P.forEach(p => p.variants.forEach(v => { vIndex[v.id] = { p, v }; }));
  // inside the Shopify theme the real Shopify cart is the source of truth; the static site keeps it in the browser
  const CTX = window.GRIPT_CTX || {};
  const SHOP_CART = !!CTX.cart;
  const fromShop = c => c.items.filter(it => vIndex[it.variant_id]).reduce((a, it) => {
    const ex = a.find(i => i.id === it.variant_id); ex ? ex.qty += it.quantity : a.push({ id: it.variant_id, qty: it.quantity }); return a;
  }, []);
  let cart = [];
  if (SHOP_CART) cart = fromShop(CTX.cart);
  else try { cart = JSON.parse(localStorage.getItem(KEY) || '[]').filter(i => vIndex[i.id]); } catch (e) { cart = []; }
  let remote = SHOP_CART ? Object.fromEntries(cart.map(i => [i.id, i.qty])) : {};
  let queue = Promise.resolve(), version = 0;
  function adopt(c, sent) {
    remote = Object.fromEntries(fromShop(c).map(i => [i.id, i.qty]));
    if (sent !== version) return; // newer local changes are still on their way
    const next = fromShop(c).sort((a, b) => cart.findIndex(i => i.id === a.id) - cart.findIndex(i => i.id === b.id));
    if (JSON.stringify(next) !== JSON.stringify(cart)) { cart = next; updateCount(); renderCart(); }
  }
  function save() {
    if (!SHOP_CART) { try { localStorage.setItem(KEY, JSON.stringify(cart)); } catch (e) { /* storage unavailable */ } return; }
    const sent = ++version;
    queue = queue.then(() => {
      const updates = {};
      new Set([...Object.keys(remote), ...cart.map(i => String(i.id))]).forEach(id => {
        const q = (cart.find(i => String(i.id) === id) || {}).qty || 0;
        if ((remote[id] || 0) !== q) updates[id] = q;
      });
      if (!Object.keys(updates).length) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(c => adopt(c, sent))
        .catch(() => fetch('/cart.js').then(r => r.json()).then(c => { adopt(c, version); toast('Some items couldn’t be updated'); }).catch(() => {}));
    });
  }
  if (SHOP_CART) addEventListener('pageshow', e => { if (e.persisted) fetch('/cart.js').then(r => r.json()).then(c => adopt(c, version)).catch(() => {}); });
  const subtotal = () => cart.reduce((s, i) => s + vIndex[i.id].v.price * i.qty, 0);
  const count = () => cart.reduce((s, i) => s + i.qty, 0);

  function add(id, qty = 1, open = true) {
    id = Number(id);
    if (!vIndex[id]) return;
    const ex = cart.find(i => i.id === id);
    ex ? ex.qty += qty : cart.push({ id, qty });
    save(); updateCount(true);
    if (open) openCart(); else { renderCart(); toast('Added to bag'); }
  }
  let removed = null, removedT;
  function setQty(id, qty) {
    const ix = cart.findIndex(i => i.id === id); if (ix < 0) return;
    if (qty <= 0) {
      // keep the line so it can be restored from the drawer
      removed = { ...cart[ix], ix }; clearTimeout(removedT);
      removedT = setTimeout(() => { removed = null; renderCart(); }, 6000);
    }
    cart[ix].qty = Math.min(20, qty); cart = cart.filter(i => i.qty > 0); save(); updateCount(); renderCart();
  }
  function undoRemove() {
    if (!removed) return;
    cart.splice(Math.min(removed.ix, cart.length), 0, { id: removed.id, qty: removed.qty });
    removed = null; clearTimeout(removedT); save(); updateCount(); renderCart();
  }
  function updateCount(bump) {
    const n = count(), el = $('#cartCount');
    el.textContent = n; el.classList.toggle('has', n > 0);
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    $('#dCount').textContent = n;
  }
  function checkoutUrl() { return SHOP_CART ? '/checkout' : STORE + '/cart/' + cart.map(i => i.id + ':' + i.qty).join(','); }
  const savings = () => cart.reduce((s, i) => { const v = vIndex[i.id].v; return s + (v.compare > v.price ? (v.compare - v.price) * i.qty : 0); }, 0);
  const firstAvail = p => p.variants.find(v => v.available) || p.variants[0];

  /* Essentials Bundle = bag + palm protectors + massage gun, sold together for less */
  const BUNDLE = 'essentials-gym-bundle';
  function bundleOffer() {
    const b = byHandle[BUNDLE];
    if (!b || cart.some(i => vIndex[i.id].p.handle === BUNDLE)) return null;
    const lines = PARTS.map(h => cart.find(i => vIndex[i.id].p.handle === h));
    const have = lines.filter(Boolean);
    if (have.length < 2) return null;
    const gun = lines[2] && vIndex[lines[2].id].v.title;
    const bv = b.variants.find(v => v.available && v.title === gun) || firstAvail(b);
    const full = PARTS.reduce((s, h) => s + firstAvail(byHandle[h]).price, 0);
    const delta = bv.price - have.reduce((s, i) => s + vIndex[i.id].v.price, 0);
    const missing = PARTS.filter((h, k) => !lines[k]).map(h => name(byHandle[h]));
    return { bv, lines: have, save: full - bv.price, delta, missing };
  }
  function swapToBundle() {
    const o = bundleOffer(); if (!o) return;
    o.lines.forEach(l => { l.qty -= 1; });
    cart = cart.filter(i => i.qty > 0);
    cart.push({ id: o.bv.id, qty: 1 });
    save(); updateCount(true); renderCart(); toast('Switched to the Essentials Bundle');
  }

  function renderCart() {
    const sub = subtotal(), left = Math.max(0, FREE_SHIP - sub);
    $('#ship').classList.toggle('is-free', left === 0);
    $('#shipMsg').innerHTML = left === 0 ? '<b>Free shipping unlocked.</b> Delivered in 3–10 days.' : `Add <b>${money(left)}</b> more for free shipping.`;
    $('#shipBar').style.width = Math.min(100, sub / FREE_SHIP * 100) + '%';
    const items = $('#dItems'), ft = $('#dFt');
    const undo = removed ? `<div class="cundo"><span>Removed ${esc(name(vIndex[removed.id].p))}</span><button type="button" data-undo>Undo</button></div>` : '';
    if (!cart.length) {
      items.innerHTML = undo + `<div class="drawer__empty"><p class="display">Bag's empty</p><p>Your gear is still on the floor. Let’s fix that.</p><a class="btn btn-dark" href="/collections/shop-all">Shop all ${I.arrow}</a></div>` + upsell(left);
      ft.innerHTML = '';
      ft.hidden = true;
      return;
    }
    ft.hidden = false;
    const o = bundleOffer();
    const offer = o ? `<div class="boffer">
        <img src="${img(byHandle[BUNDLE].images[0], 160)}" alt="">
        <div><b>Switch to the Essentials Bundle</b>
          <span>${!o.missing.length ? `Same three items for <strong>${money(-o.delta)} less</strong>.`
            : o.delta > 0 ? `Add the ${esc(o.missing[0])} for just <strong>+${money(o.delta)}</strong>. Saves ${money(o.save)} vs. buying separately.`
            : `Get the ${esc(o.missing[0])} free and pay <strong>${money(-o.delta)} less</strong>.`}</span></div>
        <button type="button" data-bundle>Switch</button></div>` : '';
    items.innerHTML = undo + cart.map(i => {
      const { p, v } = vIndex[i.id];
      const was = v.compare > v.price ? `<s>${money(v.compare * i.qty)}</s>` : '';
      return `<div class="citem"><a href="/products/${p.handle}"><img src="${img(p.images[0], 240)}" alt=""></a>
        <div class="citem__info"><a href="/products/${p.handle}"><h5>${esc(name(p))}</h5></a>${v.title !== 'Default Title' ? `<div class="v">${esc(v.title)}</div>` : ''}
          ${v.available ? '' : '<div class="oos">Sold out. Remove it to check out.</div>'}
          <div class="citem__ctl"><div class="qty"><button type="button" data-q-id="${i.id}" data-d="-1" aria-label="${i.qty > 1 ? 'Decrease' : 'Remove'}">−</button><span>${i.qty}</span><button type="button" data-q-id="${i.id}" data-d="1" aria-label="Increase" ${i.qty >= 20 ? 'disabled' : ''}>+</button></div>
          <button class="rm" type="button" data-rm="${i.id}">Remove</button></div></div>
        <div class="p">${money(v.price * i.qty)}${was}</div></div>`;
    }).join('') + offer + upsell(left);
    const saved = savings();
    const blocked = cart.some(i => !vIndex[i.id].v.available);
    ft.innerHTML = `<div class="drawer__row"><span>Subtotal · ${count()} item${count() > 1 ? 's' : ''}</span><b>${money(sub)}</b></div>
      ${saved > 0 ? `<div class="drawer__save">You’re saving ${money(saved)}</div>` : ''}
      <small>${left === 0 ? 'Your order ships free. Taxes' : 'Shipping and taxes'} calculated at checkout.</small>
      <a class="btn btn-dark btn-block drawer__go ${blocked ? 'is-off' : ''}" href="${blocked ? '#' : checkoutUrl()}" ${blocked ? 'aria-disabled="true"' : ''}>${I.lock} Checkout · ${money(sub)}</a>
      <div class="drawer__trust"><span>Secure checkout by Shopify</span><span>Ships in 3–10 days</span></div>
      <button class="drawer__cont" type="button" data-close-cart>Continue shopping</button>`;
  }
  function upsell(gap) {
    const inCart = new Set(cart.map(i => vIndex[i.id].p.handle));
    // items that unlock free shipping on their own come first, cheapest of those first
    const order = cart.length ? ['palm-protectors', 'gym-water-bottle', 'lifting-hooks', 'magnetic-gym-bag', 'performance-cap', 'electric-protein-shaker']
      : ['magnetic-gym-bag', 'essentials-gym-bundle', 'palm-protectors'];
    const picks = order
      .filter(h => !inCart.has(h) && byHandle[h] && firstAvail(byHandle[h]).available)
      .map(h => ({ p: byHandle[h], v: firstAvail(byHandle[h]) }))
      .sort((a, b) => gap > 0 && cart.length ? ((a.v.price < gap) - (b.v.price < gap)) || a.v.price - b.v.price : 0)
      .slice(0, 3);
    if (!picks.length) return '';
    return `<div class="upsell"><h6>${cart.length ? 'Complete the system' : 'Start with the essentials'}</h6><div class="upsell__row">${picks.map(({ p, v }) => `<div class="upsell__card"><a href="/products/${p.handle}"><img src="${img(p.images[0], 160)}" alt=""></a><div><b>${esc(name(p))}</b>${money(v.price)}${gap > 0 && cart.length && v.price >= gap ? '<em>Unlocks free shipping</em>' : ''}</div><button type="button" data-add="${v.id}" aria-label="Add ${esc(name(p))}">+</button></div>`).join('')}</div></div>`;
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); add(a.dataset.add, Number(a.dataset.qty || 1), !a.closest('.drawer')); return; }
    const qb = e.target.closest('[data-q-id]');
    if (qb) { const id = Number(qb.dataset.qId); const it = cart.find(i => i.id === id); if (it) setQty(id, it.qty + Number(qb.dataset.d)); return; }
    const rm = e.target.closest('[data-rm]');
    if (rm) { setQty(Number(rm.dataset.rm), 0); return; }
    if (e.target.closest('[data-undo]')) { undoRemove(); return; }
    if (e.target.closest('[data-bundle]')) { swapToBundle(); return; }
    if (e.target.closest('.drawer__go.is-off')) e.preventDefault();
    if (e.target.closest('.drawer__cont')) closeAll();
  });
  updateCount();
  renderCart();

  let toastT;
  function toast(msg) { const t = $('#toast'); t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2200); }

  /* ---------------- rails ---------------- */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach(wrap => {
      const rail = $('.rail', wrap), prog = $('.rail-prog i', wrap);
      const step = () => rail.clientWidth * .8;
      $$('[data-rail-prev]', wrap).forEach(b => b.onclick = () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      $$('[data-rail-next]', wrap).forEach(b => b.onclick = () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      if (prog) {
        const upd = () => { const max = rail.scrollWidth - rail.clientWidth; const r = rail.clientWidth / rail.scrollWidth; prog.style.width = r * 100 + '%'; prog.style.transform = `translateX(${max > 0 ? rail.scrollLeft / max * (1 / r - 1) * 100 : 0}%)`; };
        rail.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
      }
    });
  }

  /* ---------------- page transition ---------------- */
  const pt = $('#pt');
  // safety net: never let the entry curtain linger if CSS animations are paused or delayed
  setTimeout(() => { if (!pt.classList.contains('is-in')) pt.classList.add('is-skip'); }, 1300);
  addEventListener('pageshow', e => { if (e.persisted) { pt.classList.remove('is-in'); pt.classList.add('is-skip'); } });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search && url.hash)) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault();
    closeAll();
    pt.classList.remove('is-skip'); pt.classList.add('is-in');
    setTimeout(() => { location.href = url.href; }, 560);
  });

  /* ---------------- header behaviour ---------------- */
  const top = $('#top');
  let lastY = 0;
  function onScroll(y) {
    hdr.classList.toggle('is-solid', y > 40);
    const hide = y > 260 && y > lastY + 2 && !mega.classList.contains('is-open');
    const show = y < lastY - 2 || y < 260;
    if (hide) top.classList.add('is-hidden');
    else if (show) top.classList.remove('is-hidden');
    document.body.classList.toggle('hdr-shown', !top.classList.contains('is-hidden'));
    lastY = y;
  }
  addEventListener('scroll', () => onScroll(scrollY), { passive: true });
  onScroll(scrollY);

  /* ---------------- cursor + magnetic ---------------- */
  const cursor = $('#cursor');
  if (matchMedia('(pointer:fine)').matches) {
    let cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy;
    addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; cursor.classList.add('is-on'); });
    document.addEventListener('mouseleave', () => cursor.classList.remove('is-on'));
    (function loop() { cx += (tx - cx) * .2; cy += (ty - cy) * .2; cursor.style.transform = `translate(${cx}px,${cy}px)`; requestAnimationFrame(loop); })();
    document.addEventListener('mouseover', e => {
      const t = e.target.closest('[data-cursor]');
      cursor.classList.toggle('is-big', !!t);
      if (t) cursor.firstElementChild.textContent = t.dataset.cursor;
    });
    document.addEventListener('mousemove', e => {
      $$('[data-magnetic]').forEach(el => {
        const r = el.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        const near = Math.abs(dx) < r.width && Math.abs(dy) < r.height * 1.5;
        el.style.transform = near ? `translate(${dx * .18}px,${dy * .25}px)` : '';
      });
    });
  }

  /* ---------------- motion ---------------- */
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const G = window.gsap, ST = window.ScrollTrigger;
  const motion = { ready: !!(G && ST && !reduce), introDelay: .55 };

  function splitWords(el) {
    if (el.dataset.splitDone) return $$('.wi', el);
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const i = document.createElement('span'); i.className = 'wi'; i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') {
          if (n.children.length || /^(EM|SPAN|B|STRONG)$/.test(n.tagName)) walk(n);
        }
      });
    };
    walk(el);
    el.dataset.splitDone = '1';
    return $$('.wi', el);
  }

  function animateIn(root = document, intro = false) {
    if (!motion.ready) return;
    const delay = intro ? motion.introDelay : 0;
    $$('[data-split]', root).forEach(el => {
      const words = splitWords(el);
      const isIntro = el.dataset.split === 'intro';
      G.set(words, { yPercent: 115 });
      const tw = { yPercent: 0, duration: 1.25, ease: 'expo.out', stagger: .045 };
      if (isIntro) G.to(words, { ...tw, delay: delay + .1 });
      else G.to(words, { ...tw, scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    $$('[data-reveal]', root).forEach(el => {
      const isIntro = el.dataset.reveal === 'intro';
      G.set(el, { y: 50, autoAlpha: 0 });
      const tw = { y: 0, autoAlpha: 1, duration: 1.2, ease: 'power4.out', delay: (Number(el.dataset.delay) || 0) + (isIntro ? delay + .35 : 0) };
      if (isIntro) G.to(el, tw);
      else G.to(el, { ...tw, scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
    });
    const cards = $$('[data-card]', root).filter(c => !c.dataset.anim);
    cards.forEach(c => { c.dataset.anim = 1; G.set(c, { y: 60, autoAlpha: 0 }); });
    ST.batch(cards, { start: 'top 95%', once: true, onEnter: b => G.to(b, { y: 0, autoAlpha: 1, duration: 1.1, ease: 'power4.out', stagger: .08, overwrite: true }) });
    $$('[data-parallax]', root).forEach(el => {
      const amt = Number(el.dataset.parallax) || 15;
      G.fromTo(el, { yPercent: -amt / 2 }, { yPercent: amt / 2, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$('[data-clip]', root).forEach(el => {
      G.fromTo(el, { clipPath: 'inset(18% 14% 18% 14% round 16px)' }, { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'none', scrollTrigger: { trigger: el, start: 'top 85%', end: 'top 15%', scrub: true } });
    });
    $$('[data-scrub-words]', root).forEach(el => {
      const words = splitWords(el);
      G.fromTo(words, { opacity: .14 }, { opacity: 1, stagger: .1, ease: 'none', scrollTrigger: { trigger: el, start: 'top 78%', end: 'bottom 50%', scrub: true } });
    });
    $$('[data-count]', root).forEach(el => {
      const end = Number(el.dataset.count), o = { v: 0 };
      G.to(o, { v: end, duration: 1.8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true }, onUpdate: () => { el.textContent = Math.round(o.v) + (el.dataset.suffix || ''); } });
    });
    $$('[data-img-reveal]', root).forEach(el => {
      const im = $('img', el);
      G.fromTo(el, { clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0% 0 0 0)', duration: 1.4, ease: 'expo.inOut', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
      if (im) G.fromTo(im, { scale: 1.3 }, { scale: 1, duration: 1.8, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true } });
    });
  }

  function initMotion() {
    if (!motion.ready) {
      $$('.marquee').forEach(m => m.classList.add('marquee--css'));
      return;
    }
    G.registerPlugin(ST);
    if (window.Lenis && !matchMedia('(pointer:coarse)').matches) {
      lenis = new window.Lenis({ lerp: .09, wheelMultiplier: 1 });
      lenis.on('scroll', e => { ST.update(); onScroll(e.scroll); marqueeVel(e.velocity); });
      G.ticker.add(t => lenis.raf(t * 1000));
      G.ticker.lagSmoothing(0);
      document.addEventListener('click', e => {
        const a = e.target.closest('a[href^="#"]');
        if (a && a.getAttribute('href').length > 1) { const t = $(a.getAttribute('href')); if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -80 }); } }
      });
    }

    /* velocity marquees */
    const mqs = $$('.marquee').map(m => {
      const track = $('.marquee__track', m);
      const dir = m.dataset.dir === 'right' ? 1 : -1;
      const tw = G.fromTo(track, { xPercent: dir < 0 ? 0 : -50 }, { xPercent: dir < 0 ? -50 : 0, duration: Number(m.dataset.speed) || 26, ease: 'none', repeat: -1 });
      return { tw, skew: m.dataset.skew !== undefined ? track : null };
    });
    function marqueeVel(v) {
      mqs.forEach(m => {
        G.to(m.tw, { timeScale: (v < 0 ? -1 : 1) * Math.min(6, 1 + Math.abs(v) / 6), duration: .3, overwrite: true });
        G.to(m.tw, { timeScale: v < 0 ? -1 : 1, duration: 1.2, delay: .3, overwrite: false });
        if (m.skew) G.to(m.skew, { skewX: G.utils.clamp(-10, 10, -v * .6), duration: .4, overwrite: true });
      });
    }
    motion.marqueeVel = marqueeVel;

    /* footer mark */
    const mark = $('[data-mark]');
    if (mark) G.from($$('span', mark), { yPercent: 100, stagger: .06, ease: 'expo.out', duration: 1.4, scrollTrigger: { trigger: mark, start: 'top 98%', once: true } });

    animateIn(document, true);
    addEventListener('load', () => ST.refresh());
  }

  $$('[data-bundle-value]').forEach(el => { const b = byHandle['essentials-gym-bundle']; if (b && compare(b)) el.textContent = money(compare(b)); });
  window.GRIPT = { P, byHandle, COLLECTIONS, inCollection, img, money, name, esc, card, add, I, minPrice, compare, colorOpt, motion, animateIn, splitWords, initRails, toast, openCart, STORE, get lenis() { return lenis; } };

  /* page scripts run first (they render DOM), then motion picks it up */
  document.addEventListener('DOMContentLoaded', () => {
    if (window.GRIPT_PAGE) window.GRIPT_PAGE(window.GRIPT);
    initRails();
    initMotion();
    if (window.GRIPT_PAGE_MOTION && motion.ready) window.GRIPT_PAGE_MOTION(window.GRIPT, window.gsap, window.ScrollTrigger);
  });
})();
